import { IftaLabelDesignTokens } from '@primeuix/themes/types/iftalabel';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t, tNum } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/iftalabel/index.ts
const il = componentCommon.iftalabel;

export const IftaLabelTelekomDT: IftaLabelDesignTokens = {
  root: {
    color: t(il.color),
    focusColor: t(il.focus.color),
    invalidColor: t(il.invalid.color),
    top: t(il.top),
    positionX: t(il.position.x),
    fontSize: t(il.font.size),
    fontWeight: tNum(il.font.weight),
  },
  input: {
    paddingTop: t(il.input.padding.top),
    paddingBottom: t(il.input.padding.bottom),
  },
};
